<template>
  <div>
    <vacancy-list class-name="archive" :list="list" is-it-search />

    <vpagination
      :params="paginationParams"
      :on-limit-change="onLimitChange"
      :on-page-change="onPageChange"
      :loading="loading"
      has_counts
      class="bottom"
      @load_more="fetch(true)"
      @change_count="change_count"
    />
  </div>
</template>

<script>
import VacancyList from '../vacancies/List.vue'

export default {
  name: 'search-vacancies',

  components: {
    VacancyList
  },

  props: {
    list: Array,
    loading: Boolean
  },

  computed: {
    searchTerm() {
      return this.$store.state.search.term
    },

    paginationParams () {
      return this.$store.state.search.vacancies.pagination
    }
  },

  methods: {
    fetch(is_load_more = false) {
      this.$store.commit('search/vacancies/set_load_more', is_load_more)
      this.$store.dispatch('search/vacancies/fetch', {searchTerm: this.searchTerm})
    },

    change_count(val) {
      this.$store.commit('search/vacancies/change_count', val);
      this.fetch();
    },

    onPageChange (pageNumber) {
      this.$store.commit('search/vacancies/updatePagination', {
        pageNumber
      })
      this.fetch()
    },

    onLimitChange (count) {
      this.$store.commit('search/vacancies/updatePagination', {
        count
      })
      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
  .bottom {
    margin-bottom: 100px;
  }
</style>
